import { ISelectorOptions } from 'components/common'
import { BodyType } from 'generated/graphql'

export const VehicleEntity = {
  MAX_REGISTRATION_NUMBER_LENGTH: 10,
  MAX_MANUFACTURER_LENGTH: 30,
  MAX_MODEL_LENGTH: 30,
  MAX_COLOUR_LENGTH: 50,
  MAX_INSURANCE_COMPANY_LENGTH: 50,
}

export const VehicleBodyTypeValues: ISelectorOptions = [
  { value: BodyType.NotSpecified, label: 'Not specified' },
  { value: BodyType.Box, label: 'Box' },
  { value: BodyType.CurtainSide, label: 'Curtain side' },
  { value: BodyType.Dropside, label: 'Dropside' },
  { value: BodyType.Flatbed, label: 'Flatbed' },
  { value: BodyType.Refrigerated, label: 'Refrigerated' },
  { value: BodyType.TempControlled, label: 'Temp controlled' },
]
